import {AfterViewChecked, Component, ElementRef, Inject, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {AuthorsListComponent} from "../../components/authors-list/authors-list.component";
import {
  AuthorsListPublicationsDetailComponent
} from "../../components/authors-list-publications-detail/authors-list-publications-detail.component";
import {Router} from "@angular/router";
import {WINDOW} from "../../window";
import {IAuthorInList} from "../../common/interfaces";
import {MatSidenavModule} from "@angular/material/sidenav";
import {MatButtonModule} from "@angular/material/button";
import {NgIf} from "@angular/common";
import {MatIcon} from "@angular/material/icon";
import {HostService} from "../../services/host.service";
import {ShareButtons} from "ngx-sharebuttons/buttons";

@Component({
  selector: 'app-author-publications-list',
  standalone: true,
  imports: [
    MatSidenavModule,
    MatButtonModule,
    MatIcon,
    AuthorsListComponent,
    AuthorsListPublicationsDetailComponent,
    NgIf,
    ShareButtons
  ],
  templateUrl: './author-publications-list.component.html',
  styleUrl: './author-publications-list.component.sass'
})
// todo: add a spinner

export class AuthorPublicationsListComponent implements AfterViewChecked, OnInit, OnDestroy {
  protected aid: string = '';
  protected authorListDrawerOpen: boolean = true;
  protected currentAuthor: IAuthorInList =  {} as IAuthorInList;
  private previousHeight: number = 0;
  private host: string | null = null;
  @ViewChild('sidenav') sideNav!: ElementRef;
  @ViewChild('publicationsDetailContainer') publicationsDetailContainer!: ElementRef;
  private readonly targetWindow;
  showPlaceholder = false;
  private placeholderTimer: any;
  // private readonly queryParamsSubscription: Subscription;

  constructor(@Inject(WINDOW) private window: Window | null, private router: Router,
              private hostService: HostService) {
    const host = hostService.host;
    if (host && /^https:\/\/[\w-]{0,25}\.?bashanfoundation\.\w{2,4}/.test(host)) {
      this.host = host;
    }
    if (window !== null) {
      this.targetWindow = window.parent;
    }
  }

  ngOnInit(): void {
    this.placeholderTimer = setTimeout(() => {
      this.showPlaceholder = true;
    }, 2000);
  }

  ngOnDestroy(): void {
    if (this.placeholderTimer) {
      clearTimeout(this.placeholderTimer);
    }
  }

  ngAfterViewChecked(): void {
    this.calculateWindow();
  }

  private calculateWindow() {
    let c = this.sideNav.nativeElement.parentElement.parentElement.parentElement;
    let d = this.sideNav.nativeElement.parentElement.parentElement;
    let e = this.sideNav.nativeElement.parentElement;
    let currentContentHeight: number = this.sideNav.nativeElement.offsetHeight;
    const publicationsDetailHeight = this.publicationsDetailContainer.nativeElement.offsetHeight;
    // console.log('currentContentHeight1:', c.offsetHeight, d.offsetHeight, e.offsetHeight, this.previousHeight, currentContentHeight, publicationsDetailHeight);

    if (currentContentHeight !== this.previousHeight || publicationsDetailHeight > currentContentHeight) {
      const newHeight = Math.max(publicationsDetailHeight, currentContentHeight) + 100;
      e.style.height = `${newHeight}px`;
      d.style.height = `${newHeight}px`;
      c.style.height = `${newHeight}px`;
      // console.log('currentContentHeight:', c.offsetHeight, d.offsetHeight, e.offsetHeight, this.previousHeight, currentContentHeight, publicationsDetailHeight);

      this.previousHeight = newHeight;
      const message = {
        contentHeight: newHeight
      };

      if (!this.targetWindow) {
        console.error('Target window not set');
        return;
      }
      if (this.host) {
        this.targetWindow.postMessage(message, this.host);
      }
    }
  }

  handleAuthorChange(newAuthor: IAuthorInList) {
    console.log('newAuthor:', newAuthor);
    if (newAuthor.id !== '0' && newAuthor.id !== '') {
      // console.log('newAuthor setting id and closing drawer:', newAuthor);
      this.aid = newAuthor.id;
      this.authorListDrawerOpen = false;
      this.currentAuthor = newAuthor;
      this.calculateWindow();
    }
  }

  getUrlForAuthor(slug: string | undefined): string {
    // console.log('slug:', slug);
    return slug && this.host ? this.host +  `/publications/author/${slug}`: 'https://bashanfoundation.org/publications/authorsList';
  }
}
